import ContentHeading from "@/components/content-heading";
import { wrapper, description } from "@/components/projects-partners/style/project-partners-classes"

const HeadingProjectsPartners: React.FC = () => {
  return (
      <div className={wrapper}>
    <ContentHeading
      h="p"
      className="justify-center"
      backdropPosition="mobile:left-4 tablet:left-8"
      fontSize="mobile:text-[2.1rem] tablet:text-5xl"
      background="bg-primary bg-opacity-60"
    >
      Projects &amp; partners
    </ContentHeading>
    <p className={description}>Partner projects with some world renowned organisations.</p>
    </div>
  );
};

export default HeadingProjectsPartners;
